import doNothing from '../../../helpers/doNothing';

const saveNewAttachments = async (
  imagesList = [],
  saveNewImages = doNothing,
  entityId,
  descId,
  fileList = [],
  saveNewFiles = doNothing
) => {
  if (imagesList.length) {
    const newImages = imagesList.filter((image) => image instanceof File);
    if (newImages.length && descId) {
      await saveNewImages(descId, newImages);
    }
  }
  if (fileList.length) {
    const newFiles = fileList.filter((file) => file instanceof File);
    if (newFiles.length && entityId) {
      await saveNewFiles(entityId, newFiles);
    }
  }
};

export default saveNewAttachments;
